var React = require('react');

function ChartPieAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.831 18c.596 0 1.087.524 1.004 1.115-1.051 7.442-7.549 13.133-15.339 12.877C6.745 31.738.263 25.256.008 17.504-.248 9.714 5.442 3.216 12.885 2.165 13.476 2.082 14 2.572 14 3.169V18h14.831zM18.05.003c7.466.515 13.433 6.481 13.948 13.947.039.569-.441 1.05-1.012 1.05H17V1.015c0-.571.48-1.052 1.05-1.012z"}));
}

ChartPieAlt.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ChartPieAlt;

ChartPieAlt.default = ChartPieAlt;
